<!-- Dialog title -->
<h1 mat-dialog-title>
  <div class="flex flex-row items-center">
    <div
      class="flex flex-row items-center mx-2 justify-center bg-accent-900 rounded-full h-10 w-10"
    >
      <mat-icon class="icon-size-5" color="primary" svgIcon="mat_solid:add"></mat-icon>
    </div>
    <span class="text-primary">{{ 'Add To ACC' | transloco }}</span>
  </div>
</h1>
<mat-divider></mat-divider>

<!-- Dialog content -->
<div
  mat-dialog-content
  class="flex flex-col mt-2 min-h-42 overflow-hidden"
  style="height: 100%; overflow: auto"
>
  <div class="w-full px-3">
    <form [formGroup]="newIssueForm" class="example-form">
      <!--      <div *ngIf="selectedProject">-->
      <!--        <div class="flex gap-2" >-->
      <!--          <span>{{ 'Project Name' | transloco }}</span>-->
      <!--          <span class="text-primary cursor-pointer" (click)="selectedProject=false">{{ 'Change' | transloco }}</span>-->
      <!--        </div>-->
      <!--        <div class="border rounded-md p-3 mt-1 mb-4 capitalize" >-->
      <!--          {{ _project.projectInfo.autodesk_account.autodesk_project_name}}-->
      <!--        </div>-->
      <!--      </div>-->
      <mat-form-field appearance="fill" class="w-full">
        <mat-label class="text-primary">{{ 'ACC Project' | transloco }}</mat-label>
        <mat-select
          (selectionChange)="getBimIssuesTypes($event.value)"
          formControlName="project_id"
        >
          <mat-option *ngFor="let project of bimProjectList" [value]="project.id">
            {{ project.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label class="text-primary">{{ 'ACC Issue Type' | transloco }}</mat-label>
        <mat-select formControlName="issueSubtypeId">
          <mat-option *ngFor="let type of issue_types" [value]="type.id">
            {{ type.title }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!--      <span class="text-secondary italic">{{'Note: you must select a project first to choose the issue type'}}</span>-->
    </form>
  </div>
</div>

<div mat-dialog-actions class="flx-row justify-end">
  <!-- Cancel button -->
  <button mat-button (click)="onNoClick()">{{ 'Cancel' | transloco }}</button>
  <!-- Add button -->
  <button
    appLoadingButton
    [loadingState]="isLoading"
    [disabled]="newIssueForm.invalid"
    mat-raised-button
    color="primary"
    (click)="createIssue()"
    cdkFocusInitial
  >
    {{ 'Add' | transloco }}
  </button>
</div>
<!--  loading animation-->
<ngx-loading [show]="isLoading"></ngx-loading>
